import React, { FC, useEffect, useRef, useState } from 'react';

import { useOnMount } from '@/shared/hooks/useOnMount';
import { MovieAnnouncement } from '@/scenarios/profiles/lib/MovieAnnouncementTypes';
import { MovieAnnouncementBackground } from '@/scenarios/profiles/components/MovieAnnouncementBackground/MovieAnnouncementBackground';

interface MovieAnnouncementsProps {
    items: MovieAnnouncement[];
    onMount?: () => void;
}

const PROFILES_PAGE_MOVIE_ANNOUNCE_DURATION = 8.5 * 1000;

export const MovieAnnouncements: FC<MovieAnnouncementsProps> = ({ items, onMount }) => {
    const [activeIndex, setActiveIndex] = useState(() => Math.floor(Math.random() * items.length));
    const timerRef = useRef<number | undefined>();

    useOnMount(onMount);

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = window.setTimeout(() => {
            const newIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
            setActiveIndex(newIndex);
        }, PROFILES_PAGE_MOVIE_ANNOUNCE_DURATION);

        return () => {
            clearTimeout(timerRef.current);
        };
    }, [activeIndex, items]);

    return (
        <>
            {items.map((movie, index) => (
                <MovieAnnouncementBackground
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    movie={movie}
                    isActive={index === activeIndex && items?.length > 1}
                    isLooped={items?.length === 1}
                />
            ))}
        </>
    );
};
